import { render, staticRenderFns } from "./order-detail.vue?vue&type=template&id=42cc5f5b&scoped=true&"
import script from "./order-detail.vue?vue&type=script&lang=js&"
export * from "./order-detail.vue?vue&type=script&lang=js&"
import style0 from "./order-detail.vue?vue&type=style&index=0&id=42cc5f5b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cc5f5b",
  null
  
)

export default component.exports